<h1 mat-dialog-title>Type locations</h1>
<div mat-dialog-content>

  <mat-form-field appearance="fill">
    <mat-label>Type</mat-label>
    <input matInput [(ngModel)]="data.value">
  </mat-form-field>
  <mat-checkbox
  class="example-margin"
  [(ngModel)]="data.disponible"
  >
  available
</mat-checkbox>
</div>
<div mat-dialog-actions>
  
  <button mat-button [mat-dialog-close]="data" >Save</button>
</div>